var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFileZip = function SvgFileZip(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#191F2E",
    d: "M10.25 11.75a1.5 1.5 0 0 1 1.5-1.5h1.5a1.5 1.5 0 0 1 1.5 1.5v1.408l.6 2.397a1.5 1.5 0 0 1-.624 1.612l-1.394.93a1.5 1.5 0 0 1-1.664 0l-1.394-.93a1.5 1.5 0 0 1-.623-1.612l.599-2.397zm3 0h-1.5v1.408q0 .184-.045.364l-.6 2.397 1.395.93 1.394-.93-.6-2.398a1.5 1.5 0 0 1-.044-.363z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#191F2E",
    d: "M3.5 3.5a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3h-12a3 3 0 0 1-3-3zM11.75 2H6.5A1.5 1.5 0 0 0 5 3.5v18A1.5 1.5 0 0 0 6.5 23h12a1.5 1.5 0 0 0 1.5-1.5v-18A1.5 1.5 0 0 0 18.5 2H14v1.5h-1.5V5H14v1.5h-1.5V8H14v1.5h-2.25V8h-1.5V6.5h1.5V5h-1.5V3.5h1.5z"
  })));
};
export default SvgFileZip;